import * as Forms from "../CardForms";
import { EditorWrapper, SectionTitle } from "./style";

const Editor = (props) => {
  const { cards, onDelete, onAddOrUpdate } = props;
  return (
    <EditorWrapper>
      <SectionTitle>카드 만들기</SectionTitle>
      <ul>
        {Object.keys(cards).map((key) => (
          <Forms.CardEditForm
            data={cards[key]}
            key={key}
            onDelete={onDelete}
            onAddOrUpdate={onAddOrUpdate}
          />
        ))}
        <Forms.CardAddForm onAddOrUpdate={onAddOrUpdate} />
      </ul>
    </EditorWrapper>
  );
};

export default Editor;
